export function processText(text) {
  return text?.toLowerCase()?.replace(/\W/g, '-');
}
